<ng-container *ngIf="orders.length <= 0">
  <div class="card shadow-sm border-0 rounded-3 overflow-hidden bg-light">
    <div class="card-body d-flex flex-column align-items-center justify-content-center py-2">
      <!-- Icon -->
      <i class="fas fa-box-open fa-4x text-muted mb-4"></i>

      <!-- Title -->
      <h5 class="fw-bold text-muted mb-3">No Recent Orders</h5>

      <!-- Subtitle -->
      <p class="text-secondary small mb-4">
        It looks like you haven't placed any orders recently.<br />
        Explore our products and start shopping today!
      </p>

      <!-- Button -->
      <button class="btn btn-danger rounded-pill px-4 py-2" (click)="redirectToShop()">
        Start Shopping
      </button>
    </div>
  </div>
</ng-container>
<div class="row mb-3">

<div *ngFor="let order of orders | slice: 0:5; let i = index" class="card shadow-0 border mb-4 col-6 col-md-12">
  <div class="card-body">
    <div class="row">
      <!-- Order ID -->
      <div class="col-md-2 text-center d-flex justify-content-center align-items-center">
        <div class="d-flex flex-column">
          <p class="text-muted mb-0 fw-bold">Order ID</p>
          <p class="text-muted mb-0">#{{ order.id }}</p>
        </div>
      </div>

      <!-- Order Date -->
      <div class="col-md-3 text-center d-flex justify-content-center align-items-center">
        <div class="d-flex flex-column">
          <p class="text-muted mb-0 fw-bold">Order Date</p>
          <p class="text-muted mb-0">{{ order.createdTimeStamp | amDateFormat: 'Do MMMM YYYY' }}</p>
        </div>
      </div>

      <!-- Quantity -->
      <div class="col-md-2 text-center d-flex justify-content-center align-items-center d-md-block d-none">
        <div class="d-flex flex-column">
          <p class="text-muted mb-0 fw-bold">Qty</p>
          <p class="text-muted mb-0">{{ order.quantity }}</p>
        </div>
      </div>

      <!-- Total Price -->
      <div class="col-md-2 text-center d-flex justify-content-center align-items-center">
        <div class="d-flex flex-column">
          <p class="text-muted mb-0 fw-bold">Total</p>
          <p class="text-muted mb-0">{{ order.totalPrice | currency:"INR" }}</p>
        </div>
      </div>

      <!-- Status -->
      <div class="col-md-3 text-center d-flex justify-content-center align-items-center">
        <div class="d-flex flex-column">
          <p class="text-muted mb-0 fw-bold">Status</p>
          <p class="text-muted mb-0">{{ order.status }}</p>
        </div>
      </div>
    </div>

    <!-- Actions or Order Details -->
    <div class="row mt-3">
      <div class="col-12 text-end">
        <div *ngIf="order.status === 'SETTLED'; else orderDetails">
          <div class="dropdown">
            <button class="btn btn-danger fs-12 fs-sm-6 text-white px-3 py-1 dropdown-toggle" type="button" id="actionMenu{{ i }}" data-bs-toggle="dropdown" aria-expanded="false">
              Actions
            </button>
            <ul class="dropdown-menu" aria-labelledby="actionMenu{{ i }}">
              <li>
                <button class="dropdown-item fs-12 fs-sm-6" (click)="downloadInvoice(order)">
                  Download Invoice
                </button>
              </li>
              <li>
                <button class="dropdown-item fs-12 fs-sm-6" (click)="navigateToOrderDetails(order)">
                  Order Details
                </button>
              </li>
            </ul>
          </div>
        </div>
        <ng-template #orderDetails>
          <button class="btn btn-danger fs-12 fs-sm-6 text-white px-3 py-1" (click)="navigateToOrderDetails(order)">
            Order Details
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</div>
</div>
